import { Button } from "../../../nq-component";
import { CURRENCY_FORMATTER } from "../utils/constants";

const MetricCard = ({ icon, label, value, trend, color, bgGradient, isLoading }) => (
  <div
    style={{
      background: bgGradient,
      borderRadius: "12px",
      padding: "20px",
      position: "relative",
      overflow: "hidden",
      transition: "all 0.3s ease",
      border: "1px solid rgba(255, 255, 255, 0.2)",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-4px)";
      e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.15)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <div style={{ position: "absolute", top: "-20px", right: "-20px", opacity: 0.1 }}>
      <i className={icon} style={{ fontSize: "100px", color: "#fff" }}></i>
    </div>
    
    <div style={{ position: "relative", zIndex: 1 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: "rgba(255, 255, 255, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(10px)",
          }}
        >
          <i className={icon} style={{ fontSize: "1.25rem", color: "#fff" }}></i>
        </div>
        {trend && (
          <div
            style={{
              padding: "4px 8px",
              borderRadius: "6px",
              background: "rgba(255, 255, 255, 0.25)",
              fontSize: "0.75rem",
              color: "#fff",
              fontWeight: "600",
            }}
          >
            {trend}
          </div>
        )}
      </div>
      
      <div style={{ fontSize: "0.8125rem", color: "rgba(255, 255, 255, 0.9)", fontWeight: "500", marginBottom: "4px" }}>
        {label}
      </div>
      
      <div style={{ fontSize: "1.5rem", fontWeight: "700", color: "#fff" }}>
        {isLoading ? (
          <div style={{ 
            width: "60%", 
            height: "24px", 
            background: "rgba(255, 255, 255, 0.3)", 
            borderRadius: "4px",
            animation: "pulse 1.5s ease-in-out infinite"
          }}></div>
        ) : (
          value
        )}
      </div>
    </div>
  </div>
);

const ReportSummary = ({
  totals,
  voidTotals,
  aggregatedData,
  store,
  exportCSV,
}) => {
  const isLoading = store && (!aggregatedData || Object.keys(aggregatedData).length === 0);

  return (
    <div style={{ padding: "24px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px" }}>
        <div>
          <h4 style={{ color: "#111827", fontSize: "1.5rem", fontWeight: "700", margin: 0, marginBottom: "4px" }}>
            Financial Dashboard
          </h4>
          <p style={{ color: "#6B7280", fontSize: "0.9375rem", margin: 0 }}>
            Real-time overview of sales and transactions
          </p>
        </div>
        <Button
          className="btn"
          style={{
            background: "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
            border: "none",
            padding: "10px 20px",
            fontSize: "0.9375rem",
            borderRadius: "10px",
            color: "#fff",
            fontWeight: "600",
            boxShadow: "0 4px 12px rgba(131, 193, 74, 0.3)",
            transition: "all 0.3s ease",
          }}
          onClick={() => exportCSV()}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 6px 20px rgba(131, 193, 74, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.3)";
          }}
        >
          <i className="bi bi-download me-2"></i>
          Export CSV
        </Button>
      </div>

      <div className="row g-3">
        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-graph-up-arrow"
            label="Net Sales"
            value={CURRENCY_FORMATTER.format(totals.net)}
            bgGradient="linear-gradient(135deg, #059669 0%, #047857 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-currency-dollar"
            label="Gross Sales"
            value={CURRENCY_FORMATTER.format(totals.gross)}
            bgGradient="linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-tag"
            label="Discount"
            value={CURRENCY_FORMATTER.format(totals.discount)}
            bgGradient="linear-gradient(135deg, #EC4899 0%, #DB2777 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-x-circle"
            label="Void Amount"
            value={CURRENCY_FORMATTER.format(voidTotals.amount)}
            bgGradient="linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-receipt"
            label="Pretax"
            value={CURRENCY_FORMATTER.format(totals.pretax)}
            bgGradient="linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-percent"
            label="Tax"
            value={CURRENCY_FORMATTER.format(totals.tax)}
            bgGradient="linear-gradient(135deg, #F59E0B 0%, #D97706 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-ticket-perforated"
            label="Tax Free"
            value={CURRENCY_FORMATTER.format(totals.taxFree)}
            bgGradient="linear-gradient(135deg, #10B981 0%, #059669 100%)"
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-6 col-lg-3">
          <MetricCard
            icon="bi bi-hash"
            label="Void Count"
            value={isLoading ? "..." : voidTotals.count.toLocaleString()}
            bgGradient="linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)"
            isLoading={isLoading}
          />
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default ReportSummary;
